<template>
    <div v-if="isLoading" class="calendar-toggle-slot calendar-toggle-slot-loading">
        <span class="calendar-toggle-slot-label">Loading...</span>
    </div>

    <div v-else-if="isLocked" 
        class="calendar-toggle-slot calendar-toggle-slot-locked" 
        :title="`Closed by Managers ${title}`"
        :data-slot-id="slot_id"
    >
        <span class="calendar-toggle-slot-label">
            <SlashCircle class="calendar-toggle-slot-locked-icon" />
            <span class="calendar-toggle-slot-label">Closed</span>
        </span>
    </div>

    <div v-else-if="is_private" class="calendar-toggle-slot calendar-toggle-slot-private"
        :title="title"
        :data-slot-id="slot_id"
    >
        <ToggleButton
            :value="false"
            :color="{checked: '#5bb75b', unchecked: '#666'}"
            :labels="{checked: 'Available', unchecked: 'Unavailable'}"
            @change="doRemove"
            :height="20"
            :width="90"
        />
        <!-- <span class="calendar-toggle-slot-label">Busy</span> -->
        <!-- You are 'Unavailable' -->
    </div>
    <div v-else class="calendar-toggle-slot calendar-toggle-slot-available" 
        :title="title"
        :data-slot-id="slot_id"
    >
        <ToggleButton
            :value="true"
            
            :color="{checked: '#5bb75b', unchecked: '#666'}"
            :labels="{checked: 'Available', unchecked: 'Unavailable'}"
            @change="doAdd"
            :height="20"
            :width="90"
        /><!-- 
            :switch-color="{checked: '#5bb75b', unchecked: '#666'}"
            :height="16"
            :color="{checked: '#5bb75b', unchecked: '#666'}"
            :width="35" -->
        <!-- <span class="calendar-toggle-slot-label">Free</span> -->
    </div>
</template>
<script>
import {ToggleButton} from 'vue-js-toggle-button';
import SlashCircle from '@/components/icons/SlashCircle';

// :labels="{checked: 'Open', unchecked: 'Closed'}"
                
export default {
    name: "CalendarToggleSlot",
    data: function() {
        return {
            isLoading: false,
        }
    },
    props: {
        slot_id: {
            type: Number,
            required: true,
        },
        is_private: {
            type: Boolean,
            required: true,
        },
        locked: {
            type: Number,
            required: false,
            default: 0,
        },
        title: {
            type: String,
            required: false,
            default: '',
        }
    },
    components: {
        SlashCircle,
        ToggleButton,
    },
    computed: {
        isLocked() {
            return Boolean(this.locked);
        },
    },
    methods: {
        /* Widget is totally destroyed and rebuilt, so we don't need to turn off the isLoading state */
        doAdd() {
            this.isLoading = true;
            this.$store.dispatch('meetings/sendPrivate', this.slot_id);
        },
        doRemove() {
            this.isLoading = true;
            this.$store.dispatch('meetings/sendAvailable', this.slot_id);
        }
    },
}
</script>
<style>
.calendar-toggle-slot {
    border-top: 1px solid #999;

    padding: 0;
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    line-height: 12px;
    color: #333;
}

.calendar-toggle-slot-loading {
    background: #9c9;
}
.calendar-toggle-slot-available {
    background: #5bb75b;
    background: #fff;
    color: #eee;
}
.calendar-toggle-slot-locked {
    background: var(--col-calendar-bg-light);
    color: #ddd;
}
.calendar-toggle-slot-private {
    background-color: #ddd;
    color: #333;
}

.calendar-toggle-slot-locked-icon {
    height: 12px;
    width: 12px;
}

.calendar-toggle-slot-label {
    color: inherit;
    padding-left: 0;
    /* color: #333;
    padding-left: 22px;  */
    /* 5px; */
}
.calendar-toggle-slot-locked .calendar-toggle-slot-label {
    display: none;
}

.calendar-toggle-slot .vue-js-switch {
    margin-top: 0;
}
/*
.calendar-slot-private.calendar-slot-locked {  /* -private assigned by parent component * /
    color: #aaa;
    padding-left: 22px;
}*/

</style>